import { Card, FormInstance, Row } from "antd";
import { useFetchPaymentProviders } from "../../hooks/useFetchPaymentProviders";
import { Providers } from "./Providers";
import { Methods } from "./Methods";
import { useFetchSavedMethods } from "../../hooks/useFetchSavedMethods";
import { Loader } from "../../../../components/Loader";
import { useGateway } from "../../hooks/useGateway";
import { useCallback, useState } from "react";
import { Footer } from "../Footer";
import { InfoCircleOutlined } from "@ant-design/icons";
import { useCompleteSecondStep } from "../../hooks/useCompleteSecondStep";
import { useOnMethodDeleted } from "../../hooks/useOnMethodDeleted";
import { ErrorContainer } from "./ErrorContainer";

type SecondStepProps = {
  form: FormInstance;
  request: any;
  setStep: React.Dispatch<React.SetStateAction<number>>;
  setRequest: React.Dispatch<React.SetStateAction<any>>;
};

export const SecondStep = ({
  form,
  request,
  setStep,
  setRequest,
}: SecondStepProps) => {
  const { providers, isLoading, selectedProvider, setSelectedProvider } =
    useFetchPaymentProviders();

  const [error, setError] = useState<string | null>(null);

  const [selectedOption, setSelectedOption] = useState<string>("1");

  const {
    saved,
    providerData,
    isLoading: isSavedLoading,
    setSaved,
  } = useFetchSavedMethods(selectedProvider, setSelectedOption);

  const { onDeleted } = useOnMethodDeleted(
    saved,
    selectedOption,
    setSaved,
    setSelectedOption,
  );

  const { gateway, isSaving, setIsSaving } = useGateway(
    form,
    providerData,
    selectedProvider,
    setError,
    setRequest,
    setStep,
  );

  const onBack = useCallback(() => setStep((prev) => prev - 1), [setStep]);

  const { onNext } = useCompleteSecondStep(
    form,
    selectedOption,
    gateway,
    saved,
    providerData,
    setRequest,
    setIsSaving,
    setError,
    setStep,
  );

  return (
    <Card className="step second-step">
      {isLoading ? (
        <Row className="w-100 mt-10 pt-10 justify-center">
          <Loader fontSize="64px" />
        </Row>
      ) : (
        <>
          <Providers
            data={providers}
            selectedItem={selectedProvider}
            setSelectedItem={setSelectedProvider}
          />
          {isSavedLoading ? (
            <Loader fontSize="32px" />
          ) : (
            <>
              <Methods
                form={form}
                selectedOption={selectedOption}
                data={saved}
                providerOptions={providerData.options}
                selectedItem={selectedProvider}
                setRequest={setRequest}
                setSelectedOption={setSelectedOption}
                onDeleted={onDeleted}
              />
              <Row className="w-100 align-start desc-container mb-10">
                <InfoCircleOutlined className="mr-2 text-md title" />
                <p className="my-0 text-md title desc">
                  If this payment is returned due to incorrect banking
                  information, a <b>$25 returned payment fee</b> will be charged
                  to your account.
                </p>
              </Row>
              {error && <ErrorContainer title={error} />}
              <Footer
                submitLabel="Next to Preview"
                isSaving={isSaving}
                onBack={onBack}
                onNext={onNext}
              />
            </>
          )}
        </>
      )}
    </Card>
  );
};
